<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter" id="structure" role="doc-chapter">
<div class="epigraph" role="doc-epigraph">
<p class="epf"><span aria-label="v" class="page" epub:type="pagebreak" id="pv" role="doc-pagebreak"></span>The best place to view Los Angeles of the next millennium is from the ruins of its alternative future.</p>
<p class="ept">Mike Davis, <i>city of quartz: excavating the future in los angeles</i></p>
<p class="epf">Trade is our nation’s economic lifeblood. You are helping to keep that lifeblood healthy and running.</p>
<p class="ept">Alan Cranston, former US senator from California, in a speech praising the Port of Long Beach</p>
<p class="epf">Welcome to San Pedro Bay, home to the nation’s largest port complex and millions of plants and animals . . .</p>
<p class="ept">Port of Los Angeles brochure “Harbor Habitat: Our Biological Treasures”</p>
<p class="epf">Infrastructure is the spine of the Wiindigo, but is also the essential architecture of transition to a decolonized future.</p>
<p class="ept">Winona LaDuke and Deborah Cowen, “Beyond Wiindigo Infrastructure”</p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-dunbar-hester-0005.vue?06cc5998